import { useQuery } from '@tanstack/react-query'
import { getDownloadUrlService } from 'core/service/hk-web/common/api'
import { TCustomUseQueryOptions } from '../../type'
import { getWebConfigService } from 'core/service/hk-web/public/common/api'

export const useDownloadUrlServiceQuery = (options?: TCustomUseQueryOptions) => {
  return useQuery({
    ...options,
    queryKey: ['downloadUrlService'],
    queryFn: getDownloadUrlService,
  })
}

// getWebConfigService
export const useWebConfigServiceQuery = (options?: TCustomUseQueryOptions) => {
  return useQuery({
    ...options,
    queryKey: ['webConfigService'],
    queryFn: getWebConfigService,
  })
}
